<template>
  <div class="container">
    <div class="icon_lock"></div>
    <p style="text-align: center;font-size: 0.9rem">易贝乐会员才可操作此功能</p>
  </div>
</template>

<script>
  export default {
    name: '',
    data () {
      return {
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/common.css';
  .container {
    background-color: #fff;
  }
  .icon_lock {
    width: 6rem;
    height: 8rem;  
    background: url("../assets/images/icon_lock.png") no-repeat center;
    background-size: 6rem 8rem;
    margin: 7rem auto 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/pages/E010010.vue